module.exports = __WEBPACK_EXTERNAL_MODULE_30__;


/*****************
 ** WEBPACK FOOTER
 ** external "Tether"
 ** module id = 30
 ** module chunks = 0
 **/